import React from 'react'
import styled, { css } from 'styled-components'

import { withTypographyParagraph } from '@components/Typography'

export const withInput = css`
  width: 100%;
  padding: 15px;
  border: 1px solid ${({ theme }) => theme.colors.middleGray};
  border-radius: ${({ theme }) => theme.general.borderRadius};
  outline: none;

  &::placeholder {
    color: 1px solid ${({ theme }) => theme.colors.middleGray};
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.lightGray};
    color: ${({ theme }) => theme.colors.middleGray};
    border-color: ${({ theme }) => theme.colors.middleGray};
  }
  ${withTypographyParagraph}
`

const Input = styled.input`
  ${withInput}
`

export default Input
